import React from 'react';
import { Badge, Group, Modal, Stack, Text, TextInput } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink, faLinkSlash } from '@fortawesome/free-solid-svg-icons';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Button } from '../../../../../components/Button';
import { noSelectionTextInputProps } from '../../receipt/receipt-input.utils';
import { useTaxAuthorityController, TaxAuthorityProps } from './useTaxAuthorityController';

const LABELS = { disabled: 'כבוי', disconnected: 'לא מחובר', pending: 'ממתין להזדהות', connected: 'מחובר',
  'reconnect-required': 'נדרש חיבור מחדש', requesting: 'בקשה נשלחה', approved: 'הקצאה אושרה',
  refused: 'הבקשה סורבה', 'not-approved': 'הבקשה לא אושרה', failed: 'הבקשה נכשלה', unknown: 'תוצאת הבקשה אינה ידועה' };

export function TaxAuthorityModal(props: TaxAuthorityProps) {
  const controller = useTaxAuthorityController(props);
  const when = (value: string | null | undefined) => value ? new Date(value).toLocaleString('he-IL') : 'לא נמסר';
  const inputStyle: React.CSSProperties = { userSelect: 'none', WebkitTouchCallout: 'none' };
  return <Modal opened={props.opened} onClose={() => { if (!controller.busy) props.onClose(); }} title="רשות המסים" size="md" centered zIndex={310} dir="rtl">
    <Stack gap="sm">
      <Group justify="space-between">
        <Text>{controller.connection ? LABELS[controller.connection.status] : 'טוען...'}</Text>
        {controller.connection?.environment && <Badge color={controller.connection.environment === 'sandbox' ? 'orange' : 'green'}>
          {controller.connection.environment === 'sandbox' ? 'Sandbox · בדיקה בלבד' : 'Production'}
        </Badge>}
      </Group>
      <Text size="sm">תוקף טוקן גישה: {when(controller.connection?.accessExpiresAt)}</Text>
      <Text size="sm">תוקף חידוש ההרשאה: {when(controller.connection?.refreshExpiresAt)}</Text>
      {!controller.connection?.sellerVatNumber && <TextInput label="מספר עוסק של העסק" value={controller.sellerVatNumber} maxLength={9} inputMode="numeric" disabled={controller.busy}
        onChange={(event) => controller.setSellerVatNumber(event.currentTarget.value)} style={inputStyle} {...noSelectionTextInputProps} />}
      <Group>
        {controller.connection?.status !== 'connected' && <Button variant="save" onClick={controller.connect} disabled={controller.busy || !controller.canConnect}>
          <FontAwesomeIcon icon={faLink as IconProp} /> חיבור לרשות המסים
        </Button>}
        <Button variant="cancel" onClick={() => { void controller.disconnect(); }} disabled={controller.busy || !controller.connection || ['disabled', 'disconnected'].includes(controller.connection.status)}>
          <FontAwesomeIcon icon={faLinkSlash as IconProp} /> ניתוק
        </Button>
      </Group>
      {controller.invoice && <Stack gap={4}>
        <Text fw={600}>{LABELS[controller.invoice.status]}</Text>
        <Text>מספר חשבונית: {controller.invoice.referenceNumber}</Text>
        {controller.invoice.displayNumber && <Text fw={700}>מספר הקצאה: <bdi>{controller.invoice.displayNumber}</bdi></Text>}
      </Stack>}
      {controller.error && <Text role="alert" c="red">{controller.error}</Text>}
    </Stack>
  </Modal>;
}